import { render, staticRenderFns } from "./AlegereEveniment.vue?vue&type=template&id=16aea168&scoped=true&"
import script from "./AlegereEveniment.ts?vue&type=script&lang=ts&"
export * from "./AlegereEveniment.ts?vue&type=script&lang=ts&"
import style0 from "./AlegereEveniment.vue?vue&type=style&index=0&id=16aea168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16aea168",
  null
  
)

export default component.exports